import { AgentApiResponse } from "@components/ChatBot/types";
import { ChatApi } from "../chat.api";
import { ChatStrategy } from "./ChatStrategy";

export class OriginalChatStrategy implements ChatStrategy {
  private chatApi: ChatApi;

  constructor() {
    this.chatApi = new ChatApi();
  }

  async sendMessage(message: string): Promise<AgentApiResponse> {
    return this.chatApi.sendMessage(message);
  }

  getName(): string {
    return "Original Nyle Chat";
  }

  getDescription(): string {
    return "Advanced AI assistant for eCommerce growth analysis";
  }
}
